<template>
  <div id="questionManage">
    <div class="select">
      <h4 class="title1">
        <span>&nbsp;&nbsp;筛选条件</span>
      </h4>
      <div class="selectColor">
        <div class="row">
            <el-row :gutter="15">
              <el-col :span="7">
                <el-row>
                  <el-col :span="6">答案种类</el-col>
                  <el-col :span="17">
                    <el-select v-model="showParams.answerType" placeholder="请选择" >
                      <el-option label="全部" :value="null">全部</el-option>
                      <el-option label="单选" :value="1">单选</el-option>
                      <el-option label="多选" :value="2">多选</el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="7">
                <el-row>
                  <el-col :span="6">题目状态</el-col>
                  <el-col :span="17">
                  <el-select v-model="showParams.isEffective" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="生效" :value="0">生效</el-option>
                    <el-option label="失效" :value="1">失效</el-option>
                  </el-select>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
        </div>
      </div>
      <div class="row">
        <div>
          <el-row :gutter="20" >
            <el-col :span="2" :offset="5">
              <el-button type="primary" @click="reset()">重置</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="search()">筛选</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="select">
      <h4 class="title1">
        <span>&nbsp;&nbsp;搜索</span>
      </h4>
      <div class="row">
        <el-row :gutter="20" >
          <el-col :span="17">
            <el-input v-model="showParams.subject"/>
          </el-col>
          <el-col :span="2" :offset="4">
            <el-button type="primary" @click="search()">搜索</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="result">
      <h4 class="title1">
        <span>&nbsp;&nbsp;题库列表</span>
        <span style="float:right;margin-right:20px;">
            <el-button size="mini" @click="batchDelete" :disabled="batchShow">删除所选择</el-button>
            <el-button size="mini" @click="show_save">新增</el-button>
            <el-upload
              class="upload-demo right"
            :action="fileUrl"
            :data="uploadData"
            ref="uploadAgent"
            :on-success="uploadSuccess"
            :headers="uploadHeader">
            <el-button size="mini" >批量导入</el-button>
            </el-upload>
        </span>
      </h4>
      <div class="result_view">
          <el-table :data="result" style="width: 100%;" @selection-change="handleSelectionChange">
              <el-table-column
              type="selection"
              width="55">
              </el-table-column>
              <el-table-column
              type="index"
              label="序号">
              </el-table-column>
              <el-table-column type="expand">
                  <template slot-scope="props">
                      <el-form label-position="left" inline class="demo-table-expand">
                          <el-row>
                              <el-col :span="20">
                                  <el-row>
                                      <el-col :span="2">
                                          题目内容
                                      </el-col>
                                      <el-col :span="22">
                                          {{ props.row.subject}}
                                      </el-col>
                                  </el-row>
                                  <el-row>
                                      <el-col :span="24">
                                          <el-row v-for="(item,index) in props.row.questionOptions" :key="index">
                                              <el-col :span="2">&nbsp;</el-col>
                                              <el-col :span="22">
                                                  {{item.optionName+'.'+item.optionDetail}}
                                              </el-col>
                                          </el-row>
                                      </el-col>
                                  </el-row>
                              </el-col>
                              <el-col :span="3" :offset="1">
                                  <el-row>
                                      <el-col :span="10">
                                          答案项
                                      </el-col>
                                      <el-col :span="2">
                                          {{ props.row.answer}}
                                      </el-col>
                                  </el-row>
                              </el-col>
                          </el-row>
                      </el-form>
                  </template>
              </el-table-column>
              <el-table-column
                  prop="subject"
                  label="题目内容"
                  width="150"
                  header-align="center"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="answerType"
                  label="答案种类"

                  header-align="center"
                  :formatter="answerType"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="manageCom"
                  label="所属地区"

                  header-align="center"
                  :formatter="manageCom"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="isEffective"
                  label="题目状态"

                  header-align="center"
                  :formatter="isEffective"
                  align="center">
              </el-table-column>
              <el-table-column width="220" label="操作" header-align="center" align="center">
                  <template slot-scope="scope">
                      <el-button
                      v-if="scope.row.isEffective!='0'"
                      size="mini"
                      @click="Edit(scope.$index, scope.row)">编辑</el-button>
                      <el-button
                      size="mini"
                      v-if="scope.row.isEffective=='0'"
                      @click="tabEffective(scope.$index, scope.row, 1)">失效</el-button>
                      <el-button
                      size="mini"
                      v-if="scope.row.isEffective!='0'"
                      @click="tabEffective(scope.$index, scope.row, 0)">生效</el-button>
                      <el-button
                      size="mini"
                      v-if="scope.row.isEffective!='0'"
                      @click="Delete(scope.$index, scope.row)">删除</el-button>
                  </template>
              </el-table-column>
          </el-table>
      </div>
      <div>
          <div>

          </div>
          <el-pagination
          class="my-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryReq.currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          prev-click
          next-click
          :total="total">
          </el-pagination>
      </div>
    </div>
    <el-dialog title="新增试题" :visible.sync="saveVisible" @close="close">
      <el-input type="textarea" validate-event v-model="saveAndUpdateReq.subject" placeholder="请输入题目内容" maxlength="200"></el-input>
      <div>
          <el-checkbox-group v-model="correctAnswer">
              <el-row v-for="item in optionCount" :key="item" class="option-row">
                  <el-col :span="2">
                      <el-checkbox :label="optionChar[item-1]" class="checkbox"></el-checkbox>
                  </el-col>
                  <el-col :span="22">
                      <el-input v-model="saveAndUpdateReq.options[item-1]" placeholder="请输选项" maxlength="50"></el-input>
                  </el-col>
              </el-row>
          </el-checkbox-group>
      </div>
      <el-row class="option-row">在正确答案面前勾选可以多选</el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="saveVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitQuestion">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑试题" :visible.sync="updateVisible" @close="close">
      <el-input type="textarea" v-model="saveAndUpdateReq1.subject" placeholder="请输入题目内容"></el-input>
      <div>
        <el-checkbox-group v-model="correctAnswer">
          <el-row v-for="item in optionCount" :key="item" class="option-row">
            <el-col :span="2">
                <el-checkbox :label="optionChar[item-1]" class="checkbox"></el-checkbox>
            </el-col>
            <el-col :span="22">
                <el-input v-model="saveAndUpdateReq1.options[item-1]" placeholder="请输选项"></el-input>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <div>确认删除？ </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"  @click="submitDelete">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/modules/api.js'
import url from '@/modules/url.js'
import sessionStorage from '@/components/cache'
import getIP from '@/components/utils/getIP'
export default {
  name: 'questionManage',
  data () {
    return {
      // 试题选项
      optionCount: 4,
      optionChar: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'],
      tempOption: [],
      dialogVisible:false,
      row:'',
      // 机构选项
      ManageComOptions: null,
      // 页面展示所需的变量
      showParams: {
        subject: null,
        questionType: '4',
        difficulty: null,
        manageCom: null,
        answer: null,
        isEffective: null,
        answerType: null
      },
      // 查询返回的结果
      result: null,
      // 多选框选中的数据
      checkedQuestion: [],
      // 选中的问题的类型
      checkedQuestionEff: [],
      batchInvalid: true,
      batchShow: true,
      // 控制新增dialog的弹出
      saveVisible: false,
      // 控制更新dialog的弹出
      updateVisible: false,
      // 查询请求参数
      queryReq: {
        subject: '',
        questionType: '4',
        difficulty: '',
        manageCom: '',
        isEffective: '',
        answerType: '',
        pageSize: 10,
        currentPage: 1,
        offset: 0
      },
      // 新增和更新请求参数
      saveAndUpdateReq: {
        questionCode: '',
        subject: '',
        questionType: '4',
        difficulty: '',
        manageCom: '',
        answerType: '',
        options: ['', '', '', '']
      },
      saveAndUpdateReq1: {
        questionCode: '',
        subject: '',
        questionType: '4',
        difficulty: '',
        manageCom: '',
        answerType: '',
        options: ['', '', '', '']
      },
      // 删除的请求
      deleteReq: {
        questionCodes: []
      },
      // 更新试题状态
      updateEffectReq: {
        questionCode: '',
        Effective: ''
      },
      // 临时存放数据的对象
      form: {},
      // 新增是选中的正确选项
      correctAnswer: [],
      query: {},
      total: 0,
      // 上传
      uploadData: {
        'domain': 'EXAM',
        'buz': 'EXCEL',
        'expired': 60,
        'actions': '',
        'buzId': '123'
      },
      uploadHeader: {
        'ComId': 'ebiz-agent',
        'Authorization': 'Basic ' + sessionStorage.session_get('token'),
        'Accept-Device': 'NULL',
        'Accept-DeviceOS': 'NULL',
        'Accept-Location': 'NULL',
        'Accept-ISP': 'NULL',
        'Accept-StartTime': 'NULL',
        'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
        'Accept-Attr1': getIP.getBrowserInfo(),
        'Accept-Attr2': 'PC',
        'Accept-Attr3': '',
        'Real-Ip': getIP.getBrowserInfo(),
        'Accept-Attr4': 'NULL',
        'Accept-Attr6': sessionStorage.session_get('username')
      },
      fileUrl: '',
      answerList:''
    }
  },
  watch: {
    // saveVisible: function (newValue, oldValue) {
    //   if (!newValue) {
    //     this.saveAndUpdateReq = {}
    //   }
    // },
    // updateVisible: function (newValue, oldValue) {
    //   if (!newValue) {
    //     this.saveAndUpdateReq = {}
    //   }
    // }
    checkedQuestionEff: {
      deep: true,
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal.length === 0) {
          this.batchInvalid = true
          this.batchShow = true
        } else {
          if (newVal.indexOf('0') < 0) {
            this.batchInvalid = true
            this.batchShow = false
          } else if (newVal.indexOf('1') < 0) {
            this.batchInvalid = false
            this.batchShow = true
          } else {
            this.batchInvalid = true
            this.batchShow = true
          }
        }
      }
    }

  },
  computed: {
    checkReq: function () {
      // subject  题目
      // correctAnswer 答案
      if (this.saveAndUpdateReq1.subject === '') {
        return 0
      }
      if (this.saveAndUpdateReq1.subject.length > 200) {
        return 1
      }
      for (let key in this.saveAndUpdateReq1.options) {
        if (this.saveAndUpdateReq1.options[key].length > 100) {
          return 1
        }
      }
      if (this.correctAnswer.length === 0) {
        return 2
      }
      return null
    }
  },
  methods: {
    downloadTemp () {
      // 下载导入模板
      location.href = 'static/examTemp/导入试题.xls'
    },
    reset () { // 重置
      this.showParams.questionType = '4'
      this.showParams.difficulty = null
      this.showParams.manageCom = null
      this.showParams.answerType = null
      this.showParams.isEffective = null
      this.showParams.subject = null
      this.queryReq.offset = 0
      this.queryQuestion()
    },
    close () {
      this.saveAndUpdateReq = {
        questionCode: '',
        subject: '',
        questionType: '4',
        difficulty: '',
        manageCom: '',
        answerType: '',
        options: ['', '', '', '']
      }
      this.correctAnswer = []
    },
    manageCom (row, column, cellValue, index) {
      for (let item in this.ManageComOptions) {
        if (cellValue === this.ManageComOptions[item].value) {
          return this.ManageComOptions[item].label
        }
      }
      if (cellValue === 'HO') {
        return '全国'
      }
      return '无'
    },
    difficulty (row, column, cellValue, index) {
      if (cellValue === 0) {
        return '简单题'
      } else if (cellValue === 1) {
        return '中等题'
      } else {
        return '困难题'
      }
    },
    isEffective (row, column, cellValue, index) {
      if (cellValue === '0') {
        return '生效'
      } else {
        return '失效'
      }
    },
    answerType (row, column, cellValue, index) {
      if (cellValue === '1') {
        return '单选'
      } else {
        return '多选'
      }
    },
    // --------分页
    handleSizeChange (value) {
      this.queryReq.pageSize = value
      this.queryReq.currentPage = 1
      this.queryReq.offset = 0
      this.queryQuestion()
    },
    handleCurrentChange (value) {
      this.queryReq.currentPage = value
      this.queryReq.offset = (value - 1) * this.queryReq.pageSize
      this.queryQuestion()
    },
    // 选中的题
    handleSelectionChange (value) {
      this.checkedQuestion = []
      this.checkedQuestionEff = []
      for (let i = 0; i < value.length; i++) {
        this.checkedQuestion.push(value[i].questionCode)
        this.checkedQuestionEff.push(value[i].isEffective)
      }
    },
    // 删除
    Delete (index, row) {
           this.dialogVisible=true;
           this.row=row;



    },
    submitDelete(){
        this.deleteReq.questionCodes.push(this.row.questionCode)
      let that = this
      api.post(url.deleteQuestion, this.deleteReq, function (res) {
        if (res.result.isSuccess) {
          that.$message({
            message: '删除成功',
            type: 'success'
          })
          that.queryQuestion()
        } else {
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        }
        that.dialogVisible=false
      })
    },
    // 批量删除
    batchDelete () {
      let that = this
      this.deleteReq.questionCodes = this.checkedQuestion
      api.post(url.deleteQuestion, this.deleteReq, function (res) {
        if (res.result.isSuccess) {
          that.$message({
            message: '删除成功',
            type: 'success'
          })
          that.queryQuestion()
        } else {
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        }
      })
    },
    // 编辑题目
    Edit (index, row) {
      this.updateVisible = true
      this.saveAndUpdateReq = row
      let options = []
      for (let item in row.questionOptions) {
        options.push(row.questionOptions[item].optionDetail)
      }
      this.saveAndUpdateReq.options = options
      this.saveAndUpdateReq1 = JSON.parse(JSON.stringify(this.saveAndUpdateReq));
      this.correctAnswer = row.answer.split(',')
    },
    // 提交编辑
    submitEdit () {
      this.saveAndUpdateReq1.answer = this.correctAnswer.toString()
      let that = this
      if (this.checkReq !== null) {
        if (this.checkReq === 2) {
          that.$message({
            message: '请选择正确答案',
            type: 'error'
          })
        }
        if (this.checkReq === 1) {
          that.$message({
            message: '题目不超过200字且选项不超过100字',
            type: 'error'
          })
        }
        if (this.checkReq === 0) {
          that.$message({
            message: '题目不能为空',
            type: 'error'
          })
        }
      } else {
        this.saveAndUpdateReq1.difficulty = null
        api.post(url.saveAndUpdateQuestion, this.saveAndUpdateReq1, function (res) {
          if (res.result.isSuccess) {
           that.saveAndUpdateReq1= that.saveAndUpdateReq1 = {  questionCode: '',subject: '',questionType: '4',difficulty: '',manageCom: '',answerType: '',options: ['', '', '', '']};
            that.queryQuestion()
            that.$message({
              message: '更新成功',
              type: 'success'
            })
          } else {
            that.$message({
              message: '更新失败',
              type: 'error'
            })
          }
        })
        that.updateVisible = false
      }
    },
    // 显示新增
    show_save () {
      this.saveVisible = true
    },
    // 提交题目
    submitQuestion () {
      this.saveAndUpdateReq.answer = this.correctAnswer.toString()
      let that = this
      this.saveAndUpdateReq.options.forEach(item =>{
        if(!item.length){
            this.answerList = '1'
          }
        })
        if(this.answerList === '1'){
          that.$message({
            message: '题目选项不能为空',
            type: 'error'
          });
          this.answerList = ''
          return false
        }
        if(!this.saveAndUpdateReq.subject){
          that.$message({
            message: '题目不能为空',
            type: 'error'
          });
          return false
        }
        if(!this.saveAndUpdateReq.answer){
          that.$message({
            message: '答案不能为空',
            type: 'error'
          });
          return false
        }
        // if(!this.saveAndUpdateReq.manageCom){
        //   that.$message({
        //     message: '所属地区不能为空',
        //     type: 'error'
        //   });
        //   return false
        // }
        // if(this.saveAndUpdateReq.difficulty !== 0 && this.saveAndUpdateReq.difficulty !==1 && this.saveAndUpdateReq.difficulty !==2 ){
        //   that.$message({
        //     message: '题目难度不能为空',
        //     type: 'error'
        //   });
        //   return false
        // }
      // console.log(this.saveAndUpdateReq.questionType !== 0)
        // if(this.saveAndUpdateReq.questionType !== 0 && this.saveAndUpdateReq.questionType !==1 && this.saveAndUpdateReq.questionType !==2 ){
        //   that.$message({
        //     message: '题目种类不能为空',
        //     type: 'error'
        //   });
        //   return false
        // }
        // console.log(this.saveAndUpdateReq,'saveabupadaqqq')
      // if (this.checkReq !== null) {
        // if (this.checkReq === 2) {
        //   that.$message({
        //     message: '请选择正确答案',
        //     type: 'error'
        //   })
        // }
        // if (this.checkReq === 1) {
        //   that.$message({
        //     message: '题目不超过200字且选项不超过50字',
        //     type: 'error'
        //   })
        // }
        // if (this.checkReq === 0) {
        //   that.$message({
        //     message: '题目和选项不能为空',
        //     type: 'error'
        //   })
        // }
      // } else {
        this.saveAndUpdateReq.difficulty = null
        api.post(url.saveAndUpdateQuestion, this.saveAndUpdateReq, function (res) {
          if (res.result.isSuccess) {
            that.saveAndUpdateReq = {}
            that.queryQuestion()
            that.$message({
              message: '新增成功',
              type: 'success'
            })
            that.saveAndUpdateReq = {
              questionCode: '',
              subject: '',
              questionType: '4',
              difficulty: '',
              manageCom: '',
              answerType: '',
              options: ['', '', '', '']
            }
            that.queryQuestion()
          } else {
            that.$message({
              message: '新增失败',
              type: 'error'
            })
          }
        })
        that.saveVisible = false
      // }
    },
    // 查询题目
    queryQuestion () {
      this.queryReq.questionType = this.showParams.questionType
      this.queryReq.difficulty = this.showParams.difficulty
      this.queryReq.manageCom = this.showParams.manageCom
      this.queryReq.answerType = this.showParams.answerType
      this.queryReq.isEffective = this.showParams.isEffective
      this.queryReq.subject = this.showParams.subject

      let that = this
      api.post(url.queryQuestion, this.queryReq, function (res) {
        console.log(res.data.data,'=====================')
        that.result = res.data.data
        that.total = res.data.total
      })
    },
    search(){
      this.queryReq.offset = 0
      this.queryQuestion()
    },
    // 失效，生效
    tabEffective (index, row, value) {
      let that = this
      this.updateEffectReq.Effective = value
      this.updateEffectReq.questionCode = row.questionCode
      api.post(url.tabEffective, this.updateEffectReq, function (res) {
        that.queryQuestion()
      })
    },
    batchTabEffective (tabType) {
      let that = this
      this.updateEffectReq.Effective = tabType
      this.updateEffectReq.questionCodes = this.checkedQuestion
      api.post(url.tabEffective, this.updateEffectReq, function (res) {
        that.queryQuestion()
      })
    },
    uploadSuccess (res) {
      let that = this
      if (res.result.isSuccess === true) {
        that.$refs.uploadAgent.clearFiles()
        // 上传完成，开始导入
        api.post(url.importQuestion, {'path': api.urlDomin + res.data.fileId + '.' + res.data.ext}, function (res) {
          if (res.result.isSuccess === true) {
            // 获取全部代理人
            that.queryQuestion()
            that.$message({
              type: 'success',
              message: '导入成功'
            })
          } else {
            that.$message.error('导入失败')
          }
        })
      } else {
        that.$message.error(res.result.error)
        that.$refs.uploadAgent.clearFiles()
        // this.fileList = []
        // this.loading = false
      }
    }
  },
  mounted () {
    this.fileUrl = this.$uploadImg
    this.queryQuestion()
  }
}
</script>

<style scoped>
#questionManage >>> .el-table .cell{
    white-space: nowrap;
}
.select >>> .el-col-7{
  line-height: 2;
}
.select >>> .el-select{
  width: 100%;
}
.title1{
    background: #e0e0e0;
    height:50px;
    line-height: 50px;
    margin: 0px 0px 0px 0px;
}
.checkbox{
    position: relative;
    top:10px;
}
.option-row{
    margin-top: 15px;
}
.select{
    background: #ffffff;
    padding-bottom: 1px;
}
.opt-select{
    width: 100%;
}
.selectColor{
    padding-bottom: 1px;
}
.row{
    margin: 8px 0px 15px 10px;
}
.result_view{
    min-height:300px;
    height: auto;
    background: #ffffff
}
.right{
    margin-left: 15px;
     float: right;
}
.my-pagination{
    float: right;
}
.red{
  color: red;
  border-color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/internetQuestionManage.vue